import { createAction, props } from "@ngrx/store";
import {
  RoomBrandCaptionLowerThirdDeferredErrorVO,
  RoomBrandCaptionLowerThirdDeleteEventVO,
  RoomBrandCaptionLowerThirdSetEventVO
} from "@youm-front/room/domain";

export const roomBrandCaptionLowerThirdSetEvent = createAction(
  "[Room] Room Brand Caption Lower Third Set Event",
  props<{
    roomBrandCaptionLowerThirdSetEventVO: RoomBrandCaptionLowerThirdSetEventVO;
  }>()
);

export const roomBrandCaptionLowerThirdDeleteEvent = createAction(
  "[Room] Room Brand Caption Lower Third Delete Event",
  props<{
    roomBrandCaptionLowerThirdDeleteEventVO: RoomBrandCaptionLowerThirdDeleteEventVO;
  }>()
);

export const roomBrandCaptionLowerThirdDeferredErrorEvent = createAction(
  "[Room] Room Brand Caption Lower Third Deferred Error Event",
  props<{
    roomBrandCaptionLowerThirdDeferredErrorVO: RoomBrandCaptionLowerThirdDeferredErrorVO;
  }>()
);
